import buildAsyncCall from './asyncCall'
import * as Helpers from './helpers'

const Types = {
    DASHBOARD_INRUN_CONTENT: {
        request: 'DASHBOARD_INRUN_CONTENT##REQUEST',
        success: 'DASHBOARD_INRUN_CONTENT##SUCCESS',
        failure: 'DASHBOARD_INRUN_CONTENT##FAILURE',
    },
    DASHBOARD_INRUN_CONTENT_TOP: {
        request: 'DASHBOARD_INRUN_CONTENT_TOP##REQUEST',
        success: 'DASHBOARD_INRUN_CONTENT_TOP##SUCCESS',
        failure: 'DASHBOARD_INRUN_CONTENT_TOP##FAILURE',
    },
    DASHBOARD_INRUN_DWELLTIME: {
        request: 'DASHBOARD_INRUN_DWELLTIME##REQUEST',
        success: 'DASHBOARD_INRUN_DWELLTIME##SUCCESS',
        failure: 'DASHBOARD_INRUN_DWELLTIME##FAILURE',
    },
    DASHBOARD_INRUN_DWELLTIMELINE: {
        request: 'DASHBOARD_INRUN_DWELLTIMELINE##REQUEST',
        success: 'DASHBOARD_INRUN_DWELLTIMELINE##SUCCESS',
        failure: 'DASHBOARD_INRUN_DWELLTIMELINE##FAILURE',
    },
    DASHBOARD_INRUN_INTERACTIONS: {
        request: 'DASHBOARD_INRUN_INTERACTIONS##REQUEST',
        success: 'DASHBOARD_INRUN_INTERACTIONS##SUCCESS',
        failure: 'DASHBOARD_INRUN_INTERACTIONS##FAILURE',
    },
    DASHBOARD_INRUN_SESSIONS_COUNT: {
        request: 'DASHBOARD_INRUN_SESSIONS_COUNT##REQUEST',
        success: 'DASHBOARD_INRUN_SESSIONS_COUNT##SUCCESS',
        failure: 'DASHBOARD_INRUN_SESSIONS_COUNT##FAILURE',
    },
    DASHBOARD_INRUN_STORES_TOP: {
        request: 'DASHBOARD_INRUN_STORES_TOP##REQUEST',
        success: 'DASHBOARD_INRUN_STORES_TOP##SUCCESS',
        failure: 'DASHBOARD_INRUN_STORES_TOP##FAILURE',
    },
}

function fetchInRunContent(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('inrun/content', from, to),
        method: 'GET',
        types: [Types.DASHBOARD_INRUN_CONTENT.request, Types.DASHBOARD_INRUN_CONTENT.success, Types.DASHBOARD_INRUN_CONTENT.failure],
    })
}

function fetchInRunContentTop(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('inrun/content/top', from, to),
        method: 'GET',
        types: [Types.DASHBOARD_INRUN_CONTENT_TOP.request, Types.DASHBOARD_INRUN_CONTENT_TOP.success, Types.DASHBOARD_INRUN_CONTENT_TOP.failure],
    })
}

function fetchInRunDwellTime(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('inrun/dwelltime', from, to),
        method: 'GET',
        types: [Types.DASHBOARD_INRUN_DWELLTIME.request, Types.DASHBOARD_INRUN_DWELLTIME.success, Types.DASHBOARD_INRUN_DWELLTIME.failure],
    })
}

function fetchInRunDwellTimeline(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('inrun/dwelltime/timeline', from, to),
        method: 'GET',
        types: [Types.DASHBOARD_INRUN_DWELLTIMELINE.request, Types.DASHBOARD_INRUN_DWELLTIMELINE.success, Types.DASHBOARD_INRUN_DWELLTIMELINE.failure],
    })
}

function fetchInRunSessionCount(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('inrun/sessionscount', from, to),
        method: 'GET',
        types: [Types.DASHBOARD_INRUN_SESSIONS_COUNT.request, Types.DASHBOARD_INRUN_SESSIONS_COUNT.success, Types.DASHBOARD_INRUN_SESSIONS_COUNT.failure],
    })
}

function fetchInRunStoresTop(from, to) {
    return async (dispatch) => {
        const mainFetch = await dispatch(
            buildAsyncCall({
                endpoint: Helpers.buildUrl('inrun/stores/top', from, to),
                method: 'GET',
                types: [Types.DASHBOARD_INRUN_STORES_TOP.request, Types.DASHBOARD_INRUN_STORES_TOP.success, Types.DASHBOARD_INRUN_STORES_TOP.failure],
            })
        )
        const { type, payload, meta } = mainFetch
        const { retry } = meta

        if (type !== Types.DASHBOARD_INRUN_STORES_TOP.success && !retry) {
            return mainFetch
        }

        const promises = await Promise.all(payload.map(({ store_code: storeCode }) => dispatch(Helpers.fetchStore(storeCode))))

        return [mainFetch, ...promises]
    }
}

function fetchInRunTotalInteractions(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('inrun/interactions', from, to),
        method: 'GET',
        types: [Types.DASHBOARD_INRUN_INTERACTIONS.request, Types.DASHBOARD_INRUN_INTERACTIONS.success, Types.DASHBOARD_INRUN_INTERACTIONS.failure],
    })
}

export {
    Types,
    fetchInRunContent,
    fetchInRunContentTop,
    fetchInRunDwellTime,
    fetchInRunDwellTimeline,
    fetchInRunSessionCount,
    fetchInRunStoresTop,
    fetchInRunTotalInteractions,
}
